import axios from "../axiosInstance";
import { DownloadQuickBooksPeriodReportPdfRequest } from "./types";

export const downloadQuickBooksPeriodReportPdf = async (
  requestData: DownloadQuickBooksPeriodReportPdfRequest,
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/quickbooks-period-report/pdf",
    {
      params: requestData,
      responseType: "blob",
    },
  );

  return response.data;
};
